// Chama a função para enviar os dados para o CustomerX 
import axios from "axios";
import { parseCookies } from "nookies";

const sendDataToCustomerX = async (title: string) => {
  const cookies = parseCookies();
  const url = "https://tracker.customerx.com.br";
  const headers = {
    "Content-Type": "application/json",
    credential: "bcd8343b55ec8165698873f06d3163c7",
    key: "6bbc81182640febf773e68f7d7232670",
  };

  const data = {
    external_id_client: cookies["controlTower.code"],
    type_tracking: "screen",
    identifier: title,
    email: cookies["controlTower.email"],
  };

  try {
    await axios.post(url, data, { headers });
  } finally { /* empty */ }
};

export default sendDataToCustomerX;

